import { useMemo, useState } from 'react';
import {
  TestimonialFilter,
  TestimonialSource,
  type Testimonial,
} from '../types';

export function useFilteredTestimonials(testimonials: Testimonial[]) {
  const [filter, setFilter] = useState<TestimonialFilter>(
    TestimonialFilter.ALL
  );

  const counts = useMemo(
    () => ({
      [TestimonialFilter.ALL]: testimonials.length,
      [TestimonialFilter.LEADER]: testimonials.filter(
        (t) => t.source === TestimonialSource.LEADER
      ).length,
      [TestimonialFilter.LINKEDIN]: testimonials.filter(
        (t) => t.source === TestimonialSource.LINKEDIN
      ).length,
      [TestimonialFilter.YOUTUBE]: testimonials.filter(
        (t) => t.source === TestimonialSource.YOUTUBE
      ).length,
    }),
    [testimonials]
  );

  const filtered = useMemo(
    () =>
      filter === TestimonialFilter.ALL
        ? testimonials
        : testimonials.filter((t) => (t.source as string) === filter),
    [filter, testimonials]
  );

  return { filter, setFilter, filtered, counts };
}
